import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { type ContextMenuOnClickParams } from '../types/context-menu-onclick.type';
import { DisplayMode } from '@r-core';

import { BlueprintInstanceType, Island } from '@rta/rta-blueprint-library';

export const editIslandMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		displayModes: [DisplayMode.Overhead, DisplayMode.OverheadManufacturing],
		content: ({ controller }: ContextMenuOnClickParams): string => {
			return controller.readonly ? 'View Island' : 'Edit Island';
		},
		onClick: ({ controller, refMap }: ContextMenuOnClickParams): void => {
			let islandId = refMap?.island?.id ?? null;
			let frontPanelId = refMap?.island?.frontPanel.id ?? null;

			// if it's a countertop, then use the first island in the countertop
			// to lookup the island and frontPanel
			if (!islandId && refMap?.type === BlueprintInstanceType.Countertop) {
				[islandId] = refMap.countertop.islandIds;
				const [_type, island] = controller.kitchen.getReferenceItem(islandId) as [string, Island];
				frontPanelId = island?.frontPanel?.id;
				console.log('editIslandMenuItem: ', { islandId, frontPanelId, island });
			}

			if (islandId && frontPanelId) {
				controller.navigation.displayMode = DisplayMode.Panel;
				controller.navigation.islandId = islandId;
				controller.navigation.panelId = frontPanelId;
			}
			// }
		}
	};
};
